import { render, staticRenderFns } from "./whatsapp.vue?vue&type=template&id=1cc19a68&scoped=true&"
import script from "./whatsapp.vue?vue&type=script&lang=js&"
export * from "./whatsapp.vue?vue&type=script&lang=js&"
import style0 from "./whatsapp.vue?vue&type=style&index=0&id=1cc19a68&prod&lang=sass&scoped=true&"
import style1 from "./whatsapp.vue?vue&type=style&index=1&id=1cc19a68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc19a68",
  null
  
)

export default component.exports